import React from 'react'
import styled from 'styled-components'

interface CaseCreatedContentProps {
  caseTitle?: string
  caseType?: string
}

const ContentContainer = styled.div`
  font-size: 0.875rem;
`

const MainText = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.defaultText};
  margin-bottom: 0.25rem;
`

const SubText = styled.div`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.forecast.tertiaryText};
`

export const CaseCreatedContent: React.FC<CaseCreatedContentProps> = ({
  caseTitle,
  caseType,
}) => {
  return (
    <ContentContainer>
      <MainText>Created this case</MainText>
      {caseTitle && <SubText>Title: {caseTitle}</SubText>}
      {caseType && <SubText>Type: {caseType}</SubText>}
    </ContentContainer>
  )
}
